'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$37(ps$58) {
  this.a77 = null;
  this.a77 = ps$58;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$37 as $c_Lmealorama_jsonCodecs$package$$anon$37 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$37.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$37;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$37() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$37 as $h_Lmealorama_jsonCodecs$package$$anon$37 };
$h_Lmealorama_jsonCodecs$package$$anon$37.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a77.a.length;
});
$p.g = (function(i) {
  return this.a77.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$37 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$37, "mealorama.jsonCodecs$package$$anon$37", ({
  K0: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$37 as $d_Lmealorama_jsonCodecs$package$$anon$37 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$37.js.map
